<div class="governance-section">
  <div class="section-label">{{ 'filePreview.governance.label' | translate }}</div>

  @for (row of rows(); track row.key) {
    <button type="button" class="gov-row" [attr.aria-expanded]="isExpanded(row.key)"
            [attr.aria-controls]="'gov-body-' + row.key" (click)="toggle(row.key)">
      <span class="gov-row-label">{{ row.labelKey | translate }}</span>
      <span class="gov-row-state">
        <app-status-badge [label]="row.badge.labelKey | translate:(row.badge.labelParams ?? {})"
                          [tone]="row.badge.tone" [icon]="row.badge.icon" shape="pill" />
        <fa-duotone-icon class="gov-chevron" [class.gov-chevron--open]="isExpanded(row.key)" [icon]="faChevronRight" />
      </span>
    </button>
    @if (isExpanded(row.key)) {
      <div class="gov-body" [id]="'gov-body-' + row.key">
        @switch (row.key) {
          @case ('source')  { <app-provenance-section [item]="item()" [embedded]="true" (itemUpdated)="itemUpdated.emit($event)" /> }
          @case ('license') { <app-license-section [item]="item()" [embedded]="true" (itemUpdated)="itemUpdated.emit($event)" /> }
          @case ('lock')    { <app-compliance-lock-section [item]="item()" [embedded]="true" (itemUpdated)="itemUpdated.emit($event)" /> }
        }
      </div>
    }
  }

  <!-- Section-level action UNDER the rows — the sibling sections' actions-under-content grammar
       (.license-actions / .provenance-actions / .lock-actions). A header-right button wraps at
       sidebar width in every longer locale (QA fix, Robert 2026-07-03). -->
  @if (canCheck()) {
    <div class="gov-actions">
      <button pButton type="button" class="p-button-sm p-button-outlined" (click)="openCheck()">
        <fa-duotone-icon [icon]="faClipboardCheck" />
        {{ 'compliance.check.action' | translate }}
      </button>
    </div>
  }
</div>
